let filter_input = '';
let filter_country = 'USA';
let current_tab = 'online_store'

$(document).ready(function() {
  
    if ($('.top-read-section').length) {
        $('.top-read-blog-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $('.top-read-section .float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                smartSpeed: 800,
                loop: true,
                autoplay: true,
                autoplayTimeout: 5000,
                margin: 25,
                responsive: {
                    0: {
                        stagePadding: 20,
                        margin: 20
                    },
                    1280: {
                        margin: 25
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }
  
    if ($('.agent-reviews-section').length) {
        $('.agent-reviews-section').each(function() {
            let $carousel = $(this).find('.owl-carousel');
            let $floatNav = $carousel.next('.float-nav');
            let $imageContainer = $(this).find('.agent-image-container');
        
            $carousel.owlCarousel({
                items: 1,
                nav: true,
                mouseDrag: false,
                dots: false,
                loop: true,
                autoHeight: true,
                slideSpeed: 500,
                animateOut: 'fadeOut',
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                animateIn: 'fadeIn'
              
            }).on('changed.owl.carousel', function (event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                let $currentItem = $(event.target)
                  .find('.owl-item')
                  .eq(event.item.index)
                  .find('.item');
          
                let currentDataItem = $currentItem.data('item');
          
                // Remove .active from all images
                $imageContainer.find('img').removeClass('active');
          
                // Add .active to the matching image
                $imageContainer.find('img[data-item="' + currentDataItem + '"]').addClass('active');
                
                $floatNav.find('.owl-next').prop('disabled', false);
                $floatNav.find('.owl-prev').prop('disabled', false);
                
            });
    
            $floatNav.find('.owl-prev').on('click', function () {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function () {
                $carousel.trigger('next.owl.carousel');
            });
          
            $(this).trigger('refresh.owl.carousel');

        });
    }
  
    if ($('.renovation-collection-list').length) {
        $('.renovation-collection-list .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.parents('.renovation-collection-list').find('.float-nav');
  
            let owl = $carousel.owlCarousel({
                items: 4,
                slideBy: 4,
                nav: false,
                dots: false,
                smartSpeed: 300,
                autoHeight: true,
                margin: 20,
                responsive: {
                    0: {
                        items: 3,
                        slideBy: 3,
                        margin: 10,
                    },
                    1280: {
                        items: 4,
                        slideBy: 4,
                        margin: 20,
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;
  
                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }
  
                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });
  
            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });
          
            $(this).trigger('refresh.owl.carousel');

            $(this).find('.owl-item  .item').click(function(){
                $('.renovation-collection-list .owl-item  .item').removeClass('active');
                $(this).addClass('active');
              
                let tab_url = $('.renovation-collection-list .item.active').data('tab-url');
                $('.renovation-collection-list .product-list').hide();
                $('.renovation-collection-list .product-list[data-tab-url="'+ tab_url +'"]').show();
              
            });
          
        });
    }
  
    if ($('.student-military-banner-section').length) {
          let msgOneTimer = null
          $('.student-military-banner-section .select-o').click(function () {
              $(this).find('.select-list').slideToggle(300)
              $(this).toggleClass('active');
          })
          $('.student-military-banner-section .select-o .select-item').click(function () {
              $(this).siblings().removeClass('active').end().addClass('active')
              $(this).parents('.select-o').find('span').html($(this).text())
          })
          $('.student-military-banner-section .select-btn').click(function () {
              let url = $(this).siblings('.select-o').find('.active').data('url')
              if (url) {
                displayVerification(url)
              } else {
                clearTimeout(msgOneTimer)
                $('.student-military-banner-section .msg-one').fadeIn(300)
                msgOneTimer = setTimeout(() => {
                    $('.student-military-banner-section .msg-one').fadeOut(300)
                }, 2000);
              }
          })
        
          function displayVerification(url) {
              const verificationUrl = url
              sheerId.loadInModal(
              verificationUrl, {
                mobileRedirect: false
              });
          };
    }
  
    if ($('.student-military-how-it-work-section').length) {
        let januaryTwoTimer = null
        
        function initNum() {
            let $list = $('.january-two .two-list')
            let $Item = $('.january-two .two-item')
            $list.attr('style', `--tar-width:${$Item[0].offsetWidth -146}px;--tar-height:${$Item[0].offsetHeight - 146}px;`)
        }
        
        initNum()
        
        function januaryTwo(bol = false) {
            let $list = $('.january-two .january-dot-item')
            let $listLin = $('.january-two .january-dot-lin-item')
            let activeNum = $('.january-two .january-dot-item.active').length
            let $plist = $('.january-two .two-list')
            let $itemW = $plist.find('.two-item').outerWidth()
            $('.january-two .january-dot-item.no-tran').addClass('active')
            $('.january-two .january-dot-lin-item.no-tran').addClass('active')
            if (bol) activeNum = $('.january-two .january-dot-item.no-tran').length
            if (activeNum == $list.length) {
                $list.removeClass('active')
                $listLin.removeClass('active')
                activeNum = 0
            }
            setTimeout(() => {
                $list.eq(activeNum).addClass('active')
                $listLin.eq(activeNum).addClass('active')
                $list.removeClass('no-tran')
                $listLin.removeClass('no-tran')
                $plist.css({
                    'transform': 'translateX(-' + ($itemW + 16) * activeNum + 'px)',
                    'transition': 'all .4s ease'
                })
                januaryTwoTimer = setTimeout(() => {
                    januaryTwo()
                }, 5000);
            }, 50);
        }
        
        januaryTwo()
        
        $('.january-two .january-dot-item').click(function() {
            let index = $(this).index()
            $('.january-two .january-dot-item').each(function() {
                if ($(this).index() >= index) {
                    $(this).removeClass('no-tran active')
                }
            })
            $('.january-two .january-dot-lin-item').each(function() {
                if ($(this).index() >= index) {
                    $(this).removeClass('no-tran active')
                }
            })
        
            clearTimeout(januaryTwoTimer)
        
            $('.january-two .january-dot-item').each(function() {
                let num = $(this).index()
                if (num < index) {
                    $(this).addClass('no-tran')
                }
            })
            $('.january-two .january-dot-lin-item').each(function() {
                let num = $(this).index()
                if (num < index) {
                    $(this).addClass('no-tran')
                }
            })
            januaryTwo(true)
        })
    }
  
    if ($('.student-military-how-it-work-section').length) {
        function carouselSwiper(){
          let $p=$('.carousel-occ-box')
          let $cont = $p.find('.carousel-occ-img-cont')
          let $item = $p.find('.carousel-occ-item')
          let index = 0
          let length = $item.length
      
          function changeItem(){
            index++
            if(index==length) index = 0
            $item.removeClass('carousel1 carousel2 carousel3')
      
            $item.eq(index).addClass('carousel1')
            if(index==0){
              $item.eq(length - 1).addClass('carousel3')
            }else{
              $item.eq(index - 1).addClass('carousel3')
            }
            if(index==length-1){
              $item.eq(0).addClass('carousel2')
            }else{
              $item.eq(index + 1).addClass('carousel2')
            }
          }
      
          setInterval(() => {
            changeItem()
          }, 3500);
        }
        carouselSwiper()
    }
  
    if ($('.student-millitary-faqs-section').length) {
        $('.student-millitary-faqs-section .faqs-container').accordion({
            heightStyle: "content",
            active: false,
            collapsible: true
        });
        $('.student-millitary-faqs-section .faqs-container').accordion('option', 'active', 0);
    
        $('.student-millitary-faqs-section .faqs-list-container').each(function(){
            var $container = $(this); 
    
            $container.find('.link-tab').click(function(){
                $('.student-millitary-faqs-section .faqs-list-container .link-tab').removeClass('active');
                $(this).addClass('active');
                
                $('.student-millitary-faqs-section .tab-container-list').removeClass('active');
    
                $('.student-millitary-faqs-section .tab-container-list[data-tab-index="'+ $(this).attr('data-tab-index') +'"]').addClass('active');
                
            });
        });
    }
  
    if ($('.membership-programs-coupon-rewards-section').length) {
    }
  
    if ($('.membership-programs-earn-credits-section').length) {
        new Swiper('.membership-programs-earn-credits-section .earn-credits-slider', {
            slidesPerView: 1.3,
            spaceBetween: 20,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
              type: "progressbar"
            },
        });
    }
  
    if ($('.support-search').length) {
        let headerHeight = $('#hnz-header').height();
        $('.support-search').css('margin-top', `${headerHeight}px`);
        
        $(document).ready(function() {
          
          $(window).resize(function() {
              let headerHeight = $('#hnz-header').height();
              $('.support-search').css('margin-top', `${headerHeight}px`);
          });
        });
    }
  
    if ($('.video-support').length) {
        $('.youtube-list-container .youtube').each(function() {
            let videoId = $(this).data('yt');
            let thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
            $(this).css('background-image', `url(${thumbnailUrl})`);
      
        
            // Get the title using YouTube's oEmbed endpoint
            let oEmbedUrl = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`;
        
            $.getJSON(oEmbedUrl, function(data) {
                let title = data.title;
                // Find the corresponding h6 element and set the title
                $(this).closest('.youtube-wrapper').find('h6').text(title);
            }.bind(this));
        });
        
        $('[data-yt]').on('click', function() {
            let videoId = $(this).data('yt');
        
            let iframeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
            let iframe = `<iframe src="${iframeUrl}" frameborder="0" allowfullscreen></iframe>`;
        
            $('.mdl[data-mdl="youtube"] .youtube-wrapper').append(iframe);
            $('.mdl[data-mdl="youtube"]').fadeIn();
        
            $('body').css('overflow-y', 'hidden');
        
            $('.video-bg-text video')[0].pause();
        });
      
        $('.mdl .overlay').on('click', function() {
            let parent = $(this).parent();
            parent.fadeOut();
        
            mld_close(parent);
        });
        $('.mdl .mdl-close').on('click', function() {
            let parent = $(this).closest('.mdl');
            parent.fadeOut();
        
            mld_close(parent);
        });
        
        function mld_close(parent) {
            if ($('.video-bg-text video').length) {
                $('.video-bg-text video')[0].play();
            }
        
            if (parent.data('mdl') == 'youtube') {
                $(parent.find('.youtube-wrapper iframe').remove());
            }
            if (parent.data('mdl') == 'size-fit') {
                $(parent.find('.mdl-wrapper').css('left', '100%'));
            }
        
            $('body').css('overflow-y', 'visible');
        }
      
        $(document).on('click', '.video-mobile-toggle', function () {
            $(this).toggleClass('active');
        });
    }
  
    if ($('.still-need-help-section').length) {
        $('.more-help').next('.contact-us-information-section').css('padding', '0');
      
        window.ac = window.ac || {} 
        ac.chatLink = document.querySelector("a[href='#chat']");
      
        if (ac.chatLink) { 
          ac.chatLink.addEventListener("click", function(e) { 
            e.preventDefault(); 
            e.stopPropagation(); 
      
            document.getElementById("ShopifyChat").shadowRoot.querySelector("button.chat-toggle").click(); 
          }); 
        } 
    }

    if ($('.main-support-nav').length) {
        let headerH = $('#hnz-header').outerHeight() - 1;
        $('.main-support-nav').css('top', `${headerH}px`);
      
        const urlParams = new URLSearchParams(window.location.search);
    
        if (urlParams.has('tab')) {
            const tabValue = urlParams.get('tab');
            setTimeout(() => {
                $(`.support-nav [data-nav="${tabValue}"]`).trigger('click');
            }, 100);
            if(tabValue == 'warranty-claim' ){
                setTimeout(() => {
                    $(`.support-nav [data-nav="support-service"]`).trigger('click');
                }, 100);
                setTimeout(() => {
                  $(`.form-modal[data-modal="warranty-claim"]`).fadeIn(); 
                  $('html, body').css('overflow-y', 'hidden');
                }, 500);
            }
        }
      
        setTimeout(function() {
          hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').outerHeight();
          $('.main-support-nav').css('top', `${ hAnnouncementbarDynamic }px`);
        }, 100);

        $('.support-nav .nav-items span').click(function() {
            const targetSection = $(this).data('nav');
            const targetOffset = $('section[data-anchor="' + targetSection + '"]').offset().top - 150;
        
            $('html, body').animate({
                scrollTop: targetOffset
            }, 0);
        });
        
        $('.support-detail [data-anchor]').click(function() {
            const targetSection = $(this).data('anchor');
            const targetOffset = $('section[data-anchor="' + targetSection + '"]').offset().top - 150;
        
            $('html, body').animate({
                scrollTop: targetOffset
            }, 0);
        
            $('.support-detail [data-anchor="support-video"]').addClass('active').siblings().removeClass('active');
        });

    }
  
    if ($('.main-product-support-nav').length) {
        setTimeout(function() {
          hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').outerHeight();
          $('.main-product-support-nav').css('top', `${ hAnnouncementbarDynamic }px`);
        }, 100);
    }

    if ($('.support-detail').length) {
        let fullUrlPath = new URL(window.location.href).pathname;

        $('.support-detail .selected').each(function() {
            let linkPath = new URL($(this).attr('href'), window.location.origin).pathname;
        
            if (linkPath === fullUrlPath) {
                $(this).addClass('active');
        
                let name = $(this).html();
                let image = $(this).data('image');
        
                $('.breadcrumbs').append(`
                    <a href="javascript:void(0)">${name}</a>    
                `);
        
                $('.product-title').html(name);
                $('.product-image img').attr('src', image);
        
                let accordionItem = $(this).closest('.accordion-item');
        
                accordionItem.find('.accordion-button').removeClass('collapsed');
                accordionItem.find('.accordion-collapse').addClass('show');
        
                let index = accordionItem.index();
        
                $(`.sideline .line:eq(${index})`).addClass('active');
            }
        });
    }

    if ($('.toggles').length) {
        setTimeout(() => {
            $('.toggles').each(function() {
                let firstVisibleSpan = $(this).find('span:visible').first();
                firstVisibleSpan.addClass('active').siblings().removeClass('active');
    
                let toggle = firstVisibleSpan.data('toggle');
                $(`.nav-toggles .nav-toggle[data-toggle="${toggle}"]`).addClass('active');
            });
        }, 10);
    }

    if ($('.btn-toggles').length) {
        setTimeout(() => {
            $('.btn-toggles').each(function() {
                let firstVisibleSpan = $(this).find('.btn-toggle:visible').first();
                firstVisibleSpan.addClass('active').siblings().removeClass('active');
    
                let toggle = firstVisibleSpan.data('toggle');
                $(`.store-navs .store-nav[data-store="${toggle}"]`).addClass('active');
            });
        }, 10);
    }

    if ($('.support-video').length) {
        $('.support-detail .toggles span:eq(0)').css('display', 'inline-block');
    }
  
    if ($('.product-support').length) {
        $(document).on('click', '.product-support-mobile-toggle', function () {
            $(this).toggleClass('active');
        });
    }
    
    if ($('.support-center-faqs').length) {
        $('.support-detail .toggles span:eq(1)').css('display', 'inline-block');
    }
    
    if ($('.manuals').length) {
        $('.support-detail .toggles span:eq(2)').css('display', 'inline-block');
    }
    
    if ($('.app-support').length) {
      
        $('#qcr-code-btn').click(function(){
          $('.qr-code-modal').css('display','block');
        })
        $('.qr-code-modal .overlay, .close-btn').click(function(){
          $('.qr-code-modal').css('display','none');
        })
    }
  
    $('.product-support .toggles span, .video-support .toggles span, .support-center-faqs .toggles span, .product-tutorials .toggles span, .support-center-product-faqs .toggles span').on('click', function() {
        let toggle = $(this).data('toggle');
        $(this).addClass('active').siblings().removeClass('active');
    
        $(`.nav-toggle[data-toggle="${toggle}"]`).addClass('active').siblings().removeClass('active');
    });
    
    if ($('.product-tutorials').length) {
        $('.youtube-list-container .youtube').each(function() {
            let videoId = $(this).data('yt');
            let thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
            $(this).css('background-image', `url(${thumbnailUrl})`);
      
          
            // Get the title using YouTube's oEmbed endpoint
            let oEmbedUrl = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`;
        
            $.getJSON(oEmbedUrl, function(data) {
                let title = data.title;
                // Find the corresponding h6 element and set the title
                $(this).closest('.youtube-wrapper').find('h6').text(title);
            }.bind(this));
        });
        
        $('[data-yt]').on('click', function() {
            let videoId = $(this).data('yt');
        
            let iframeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
            let iframe = `<iframe src="${iframeUrl}" frameborder="0" allowfullscreen></iframe>`;
        
            $('.mdl[data-mdl="youtube"] .youtube-wrapper').append(iframe);
            $('.mdl[data-mdl="youtube"]').fadeIn();
        
            $('body').css('overflow-y', 'hidden');
        
            $('.video-bg-text video')[0].pause();
        });
      
        $('.mdl .overlay').on('click', function() {
            let parent = $(this).parent();
            parent.fadeOut();
        
            mld_close(parent);
        });
        $('.mdl .mdl-close').on('click', function() {
            let parent = $(this).closest('.mdl');
            parent.fadeOut();
        
            mld_close(parent);
        });
        
        function mld_close(parent) {
            if ($('.video-bg-text video').length) {
                $('.video-bg-text video')[0].play();
            }
        
            if (parent.data('mdl') == 'youtube') {
                $(parent.find('.youtube-wrapper iframe').remove());
            }
            if (parent.data('mdl') == 'size-fit') {
                $(parent.find('.mdl-wrapper').css('left', '100%'));
            }
        
            $('body').css('overflow-y', 'visible');
        }
    }
    
    if ($('.support-specs').length) {
      
        let $specsContent = $(".specs-content");
        let $btnLess = $(".btn-less");
        
        // Initially show only the first specs-content
        $('.btn-less').click(function(){
          
          if($(this).find('span').text() == 'Show Less'){
              $btnLess.addClass('active');
              $(this).find('span').text('Show More');
              $specsContent.hide().first().show();
            
          }else{
              $btnLess.removeClass('active');
              $(this).find('span').text('Show Less');
              $specsContent.show();
            
          }
        });
        
        $(document).on('click', '.tab-list-toggles h3', function () {
            let tab = $(this).data('tab');
        
            // Remove active class from all tabs and add to the clicked one
            $('.tab-list-toggles h3').removeClass('active');
            $(this).addClass('active');
        
            // Hide all specs content and show the one matching the clicked tab
            $('.specs-content').removeClass('active');
            $('.specs-content[data-tab="' + tab + '"]').addClass('active');
        });
    }
  
    if ($('.retailers-banner-slider-section').length) {
        $('.retailers-banner-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $('.retailers-banner-slider .float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                smartSpeed: 800,
                loop: true,
                autoplay: false,
                autoplayTimeout: 5000,
                margin: 5,
                responsive: {
                    0: {
                        stagePadding: 40,
                        margin: 15,
                        dots: true,
                    },
                    1280: {
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }
  
    if ($('.retailers-main-listing-section').length) {
      
        $('.tab-item').on('click', function () {
            $('.tab-item').removeClass('active');
            $(this).addClass('active');
      
            var tabToShow = $(this).data('store-tab');
          
            current_tab = tabToShow;

            if (tabToShow === 'online_store') {
                current_store_data = online_store;
            } else if (tabToShow === 'retail_stores') {
                current_store_data = retail_stores;
            } else if (tabToShow === 'authorized_dealer') {
                current_store_data = authorized_dealer;
            }
          
            $('.main-tab-container').hide();
            $('.main-tab-container[data-store-tab="' + tabToShow + '"]').show();
        });
      
        $('.main-tab-container').each(function () {
            $(this).find('.select-o').click(function(){
                $(this).find('.select-list').slideToggle(300);
                $(this).toggleClass('active');
            });
          
            $(this).find('.select-item').click(function(){
                $(this).siblings().removeClass('active').end().addClass('active')
                $(this).parents('.select-o').find('span').html($(this).text());
                filter_country = $(this).text();
              
                filterLocation(filter_country, filter_input);
            });
          
            $(this).find('.filter-input .search-btn').click(function(){
                filter_input = $('input[name="search-address"]').val();
              
                filterLocation(filter_country, filter_input);
            });
          
            $(this).find('.filter-input input').on('keyup', function() {
                filter_input = $(this).val();
                filterLocation(filter_country, filter_input);
            });
        });
      
    }
  
    if ($('.membership-programs-coupon-rewards-section').length) {
        $('.membership-programs-coupon-rewards-section .coupon-box-item').each(function() {
            var rules_btn = $(this).find('.rules-btn');
            var $modal = $('.membership-programs-coupon-rewards-section').find('.discount-modal');
        
            rules_btn.click(function(e) {
                e.stopPropagation();
                $modal.show();
                $modal.find('.coupon-rules-container').hide();
                $modal.find('.coupon-rules-container[data-modal-id="'+ rules_btn.attr('data-modal-id') +'"]').show();
            });
        
            // Close modal event
            $('.mdl-close, .mdl .overlay').click(function() {
                
            });
        });
    }
  
    if ($('.faqs-section').length) {
        $('.faqs-container').accordion({
            heightStyle: "content",
            active: false,
            collapsible: true
        });
        $('.faqs-container').accordion('option', 'active', 0);
    
        $('.faqs-list-container').each(function(){
            var $container = $(this); 
    
            $container.find('.link-tab').click(function(){
                $('.faqs-list-container .link-tab').removeClass('active');
                $(this).addClass('active');
                
                $('.tab-container-list').removeClass('active');
    
                $('.tab-container-list[data-tab-index="'+ $(this).attr('data-tab-index') +'"]').addClass('active');
                
            });
        });
    }  
  
    if ($('.blog-list-section').length) {
        const animations = ["fade-up", "fade-down", "fade-left", "fade-right"];
        const blogItems = document.querySelectorAll(".default-blog-item");
    
        blogItems.forEach(item => {
          const random = animations[Math.floor(Math.random() * animations.length)];
          item.setAttribute("data-aos", random);
        });
    }  
  
    if ($('.blog-page-subscription-form').length) {
       const form = document.getElementById("blog-newsletter");
      
        const checkboxMobile = document.getElementById("subscribe-validation-checkbox-mobile");
        const checkboxDesktop = document.getElementById("subscribe-validation-checkbox-desktop");
      
        function updateRequiredCheckbox() {
          const mobileVisible = checkboxMobile && window.getComputedStyle(checkboxMobile.closest('.validation-input')).display !== "none";
          const desktopVisible = checkboxDesktop && window.getComputedStyle(checkboxDesktop.closest('.validation-input')).display !== "none";
      
          // Ensure only the visible checkbox is required
          if (mobileVisible) {
            checkboxMobile.setAttribute('required', 'required');
            checkboxDesktop.removeAttribute('required');
          } else if (desktopVisible) {
            checkboxDesktop.setAttribute('required', 'required');
            checkboxMobile.removeAttribute('required');
          }
        }
      
        // Run on load
        updateRequiredCheckbox();
      
        // Run on window resize (e.g., responsive breakpoint changes)
        window.addEventListener('resize', updateRequiredCheckbox);
      
        form.addEventListener("submit", function (e) {
          document.querySelectorAll(".checkbox-error-message").forEach(msg => msg.remove());
      
          let activeCheckbox = null;
      
          if (checkboxMobile && window.getComputedStyle(checkboxMobile.closest('.validation-input')).display !== "none") {
            activeCheckbox = checkboxMobile;
          } else if (checkboxDesktop && window.getComputedStyle(checkboxDesktop.closest('.validation-input')).display !== "none") {
            activeCheckbox = checkboxDesktop;
          }
      
          if (activeCheckbox && !activeCheckbox.checked) {
            e.preventDefault();
      
            const message = document.createElement("p");
            message.className = "checkbox-error-message f-red body-sm mt-sm-2";
            message.textContent = "Please check the box to consent to our Terms and Privacy Policy.";
      
            activeCheckbox.closest(".validation-input").appendChild(message);
            activeCheckbox.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        });
    }
  
    if ($('.main-faqs-section').length) {
        const tabs = document.querySelectorAll(".faqs-tab-container .item");
        const contents = document.querySelectorAll(".faqs-list-container");
    
        tabs.forEach(tab => {
          tab.addEventListener("click", function () {
            // Remove active class from all tabs
            tabs.forEach(t => t.classList.remove("active"));
            // Add active to clicked tab
            this.classList.add("active");
    
            const target = this.getAttribute("data-tab");
    
            // Hide all content sections
            contents.forEach(content => {
              if (content.getAttribute("data-tab") === target) {
                content.classList.remove("d-none");
              } else {
                content.classList.add("d-none");
              }
            });
          });
        });

      
      
      $('.main-faqs-section').each(function () {
          $(this).find('.select-o').click(function(){
              $(this).find('.select-list').slideToggle(300);
              $(this).toggleClass('active');
          });
        
          $(this).find('.select-item').click(function(){
              $(this).siblings().removeClass('active').end().addClass('active')
              $(this).parents('.select-o').find('span').html($(this).text());
              
              const target = this.getAttribute("data-tab");
              // Hide all content sections
              contents.forEach(content => {
                if (content.getAttribute("data-tab") === target) {
                  content.classList.remove("d-none");
                } else {
                  content.classList.add("d-none");
                }
              });
          });
      });
    }

    if ($('.coupon-list-section').length) {
        $('.coupon-item').each(function () {
          const $item = $(this);
          const startDateStr = $item.attr('data-start-date-item'); // e.g., "Jul 10, 2025 00:00:00"
          const endDateStr = $item.attr('data-end-date-item');     // e.g., "Nov 07, 2025 14:00:00"
        
          const startDate = new Date(Date.parse(startDateStr));
          const endDate = new Date(Date.parse(endDateStr));
          if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return;
        
          const startTime = startDate.getTime();
          const endTime = endDate.getTime();
          const totalDuration = endTime - startTime;
        
          const interval = setInterval(() => {
          const now = new Date().getTime();
          const remaining = endTime - now;
        
            if (remaining <= 0) {
              clearInterval(interval);
              $item.find('.coupon-day-data').text('00');
              $item.find('.coupon-hour-data').text('00');
              $item.find('.coupon-minute-data').text('00');
              $item.find('.coupon-second-data').text('00');
              $item.find('.countdown-progress').css('width', '100%');
              return;
            }
        
            // Calculate time left
            const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
            const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
        
            // Update countdown text
            $item.find('.coupon-day-data').text(days.toString().padStart(2, '0'));
            $item.find('.coupon-hour-data').text(hours.toString().padStart(2, '0'));
            $item.find('.coupon-minute-data').text(minutes.toString().padStart(2, '0'));
            $item.find('.coupon-second-data').text(seconds.toString().padStart(2, '0'));
        
            // Calculate and update progress
            const elapsed = now - startTime;
            let progress = Math.floor((elapsed / totalDuration) * 100);
            if (progress < 1) progress = 1;
            if (progress > 100) progress = 100;
        
            $item.find('.countdown-progress').css('width', progress + '%');
          }, 1000);


          
            $(this).find('.btn-get-code').click(function() {
                  var discountCode = $(this).data('discount-code'); // Get from data attribute
                
                  navigator.clipboard.writeText(discountCode).then(function () {
                    // Show toast notification
                    var x = $('#toastCustom');
                    x.text('The discount code has been copied to the pasteboard!');
                    x.addClass('show');
                    setTimeout(function () {
                      x.removeClass('show');
                    }, 3000); // Hide after 3 seconds
                  }, function (err) {
                    console.error('Failed to copy discount code:', err);
                  });
            });
              
        });

      
    }

    if ($('.event-page-banner-countdown-container').length) {
      
          var countdownInterval = setInterval(function() {
          var now = new Date().getTime();
          if (event_page_banner_countdown_target){
              var timeDifference = event_page_banner_countdown_target - now;
          }else {
            return
          }
          
          // Calculate days, hours, minutes, and seconds
          var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
          var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
          
          // Add leading zeros if the value is less than 10
          days = days < 10 ? '0' + days : days;
          hours = hours < 10 ? '0' + hours : hours;
          minutes = minutes < 10 ? '0' + minutes : minutes;
          seconds = seconds < 10 ? '0' + seconds : seconds;
          
          // Display the result in the respective HTML elements
          $('.day-data').text(days);
          $('.hour-data').text(hours);
          $('.minute-data').text(minutes);
          $('.second-data').text(seconds);
          
          // If the countdown is finished, clear the interval
          if (timeDifference < 0) {
              clearInterval(countdownInterval);
              $('.day-data, .hour-data, .minute-data, .second-data').text('00');
              $('.countdown-container').addClass('hidden-important');
          }
      }, 1000);
    }

    if ($('.event-page-header-nav-section').length) {
  
        $('.event-page-header-nav-section').each(function () {
            var $container = $(this); 
            $container.find('.nav-item').click(function(){
              
              
                $('.nav-item').removeClass('active');
                $(this).addClass('active');
        
              
                var targetAttr = $(this).attr('data-scroll');
                var $targetSection = $('.section-scroll[data-scroll="' + targetAttr + '"]').offset().top - 150;
                $("html, body").animate({
                    scrollTop: $targetSection
                }, 1);
            });
        });
    
        $(window).on('scroll', function() {
            $(".section-scroll").each(function() {
                var sectionTop = $(this).offset().top - 170;
                var sectionBottom = sectionTop + $(this).outerHeight();
                var scrollPosition = $(window).scrollTop();
                
                var targetButton = $('.event-page-header-nav-section .nav-item[data-scroll="' + $(this).attr('data-scroll') + '"]');
            
                if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                    targetButton.addClass("active");
                    
                    // Check if the section has a data-child-scroll attribute
                    var childScroll = $(this).attr("data-child-scroll");
                    if (childScroll) {
                        $('.event-page-header-nav-section .nav-item[data-scroll="' + childScroll + '"]').addClass("active");
                    }
                } else {
                    if (!$(this).attr("data-child-scroll")) {
                        targetButton.removeClass("active");
                    }
                }
            });
        });
    }
  
    if ($('.banner-event-list-section').length) {
        var banner_event_list_slider = new Swiper('.banner-event-list-slider', {
            slidesPerView: 1.1,
            spaceBetween: 15,
            allowTouchMove: true,
            pagination: {
              el: ".swiper-pagination-event-list-slider",
              type: "progressbar"
            },
        });
        $('.link-to-policy').click(function(){
            var $targetSection = $('.event-page-policy-section').offset().top - 150;
            $("html, body").animate({
                scrollTop: $targetSection
            }, 1);
        })
    }
  
    if ($('.bundle-add-on-section').length) {
        const $trigger = $('.custom-select-trigger');
        const $optionsWrapper = $('.custom-options');
        const $options = $('.custom-option');
        const $arrow = $trigger.find('.select-arrow');  // Select the arrow image inside the trigger
      
        // Ensure the elements exist before proceeding
        if (!$trigger.length || !$optionsWrapper.length) {
          return; // This prevents further execution if elements are missing
        }
      
        // Toggle dropdown
        $trigger.on('click', function(e) {
          e.stopPropagation();
          $optionsWrapper.toggleClass('active');
          $arrow.toggleClass('rotate');  // Toggle rotate class on the arrow
        });
      
        // Handle option click (only update text)
        $options.on('click', function(e) {
          e.stopPropagation();
          $trigger.find('span').text($(this).text());
          $optionsWrapper.removeClass('active');
          $arrow.removeClass('rotate');  // Remove rotate class when option is selected
        });
      
        // Close dropdown if clicked outside
        $(document).on('click', function() {
          $optionsWrapper.removeClass('active');
          $arrow.removeClass('rotate');  // Remove rotate class when clicked outside
        });
    
    
      
      $('.custom-option').on('click', function() {
        let $selected = $(this);
        let optionID = $selected.attr('data-option-id');
        let variantId = $selected.attr('data-variant-id');
        let salePrice = $selected.attr('data-sale-price');
        let comparePrice = $selected.attr('data-compare-price');
        let variantURL = $selected.attr('data-product-url'); // if you have product_url
    
        // Update the href for Add to Cart
        let newHref = "/cart/" + variantId + ":1";
    
        // Activate the correct variant-option-list
        $('.bundle-add-on-section .variant-option-list').removeClass('active');
        $('.bundle-add-on-section .variant-option-list[option-id="'+ optionID +'"]').addClass('active');
    
        // Update price fields
        $('.bundle-add-on-section .bottom-info .text-sale-price').html(salePrice);
        $('.bundle-add-on-section .bottom-info .text-compare-price').html(comparePrice);
    
        // Update buttons
        $('.bundle-add-on-section .product-buttons .btn-add-to-cart').attr("href", newHref);
        $('.bundle-add-on-section .product-buttons .btn-learn-more').attr("href", variantURL);
      });
    }
  
    if ($('.event-page-faqs-section').length) {
        $('.event-page-faqs-section .faqs-container').accordion({
            heightStyle: "content",
            active: false,
            collapsible: true
        });
        $('.event-page-faqs-section .faqs-container').accordion('option', 'active', 0);
    
        $('.event-page-faqs-section .faqs-list-container').each(function(){
            var $container = $(this); 
    
            $container.find('.link-tab').click(function(){
                $('.event-page-faqs-section .faqs-list-container .link-tab').removeClass('active');
                $(this).addClass('active');
                
                $('.event-page-faqs-section .tab-container-list').removeClass('active');
    
                $('.event-page-faqs-section .tab-container-list[data-tab-index="'+ $(this).attr('data-tab-index') +'"]').addClass('active');
                
            });
        });
    }
  
    if ($('.full-product-info-list-section').length) {
        document.querySelectorAll('.product-slider-wrapper').forEach((wrapper) => {
            const mainSliderEl = wrapper.querySelector('.main-media-container'); // scoped inside wrapper
            const thumbSliderEl = wrapper.querySelector('.media-thumbnail');
            const nextBtn = wrapper.querySelector('.main-media-button-next');
            const prevBtn = wrapper.querySelector('.main-media-button-prev');

            if (!mainSliderEl || !thumbSliderEl) return; // safety check

            const sliderThumbnail = new Swiper(thumbSliderEl, {
            spaceBetween: 10,
            slidesPerView: 6.7,
            watchSlidesProgress: true,
            breakpoints: {
                0: { slidesPerView: 5.7 },
                768: { slidesPerView: 5.7 },
                1024: { slidesPerView: 6.7 },
            },
            });

            new Swiper(mainSliderEl, {
            spaceBetween: 0,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            thumbs: {
                swiper: sliderThumbnail,
            },
            });
        });
    }
  
    if ($('.event-page-policy-section').length) {
        document.querySelector('.toggle-policy-btn').addEventListener('click', function() {
          var wrapper = document.querySelector('.policy-content-wrapper');
          var spanText = this.querySelector('span'); // target the span specifically
          
          wrapper.classList.toggle('expanded');
          
          if(wrapper.classList.contains('expanded')) {
            spanText.textContent = 'View Less';
          } else {
            spanText.textContent = 'View More';
        
            // When collapsing (View Less), scroll to section
            var $targetSection = $('.event-page-policy-section').offset().top - 150;
            $('html, body').animate({
              scrollTop: $targetSection
            }, 300); // You can adjust the animation speed (300ms here)
          }
        });
    }
  
    if ($('.event-page-product-slider-section').length) {
        var product_slider_container_section = new Swiper('.product-slider-container', {
            slidesPerView: 4,
            spaceBetween: 25,
            allowTouchMove: true,
            navigation: {
                nextEl: '.event-page-product-button-next',
                prevEl: '.event-page-product-button-prev',
            },
            breakpoints: {
                // For screens greater than or equal to 1024px (Desktop)
                1024: {
                    slidesPerView: 4,   // 3 slides for desktop
                    spaceBetween: 25,
                },
                // For screens between 768px and 1023px (Tablet)
                768: {
                    slidesPerView: 3,   // 1 slide for tablets
                    spaceBetween: 20,
                },
                // For screens less than 768px (Mobile)
                0: {
                    slidesPerView: 2,   // 1 slide for mobile
                    spaceBetween: 15,
                },
            }
        });
    }
  
    function initEventPageTabEvent($section) {
        function updateProgress($parentTab) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
        
            var $eventItems = $parentTab.find('.event-tab-item');
            var totalItems = $eventItems.length;
            var progressWidth = 0;
        
            var $activeItem = null;
        
            $eventItems.each(function(index) {
                var $this = $(this);
                var startDate = new Date($this.data('date-start'));
                var endDate = new Date($this.data('date-end'));
        
                startDate.setHours(0, 0, 0, 0);
                endDate.setHours(0, 0, 0, 0);
        
                var formId = $this.attr('data-form-id');
        
                if (today >= startDate && today <= endDate) {
                    $this.addClass('active');
                    $parentTab.find('.vertical-item[data-form-id="' + formId + '"]').addClass('active');
                    $activeItem = $this;
        
                    // Set the progress bar width based on the index and total items
                    if (totalItems === 2) {
                        progressWidth = (index === 0) ? 50 : 100;
                    } else if (totalItems === 3) {
                        progressWidth = [16, 50, 100][index];
                    }
                } else {
                    $this.removeClass('active');
                    $parentTab.find('.vertical-item[data-form-id="' + formId + '"]').removeClass('active');
                }
            });
        
            // Scroll into view for active item (only on mobile)
            if ($activeItem && $parentTab.hasClass('mobile-side')) {
                var $scrollContainer = $parentTab.find('.scrollable-content');
                var scrollLeft = $activeItem.position().left + $scrollContainer.scrollLeft() - 16;
                $scrollContainer.animate({
                    scrollLeft: scrollLeft
                }, 400);
            }
        
            // Update the progress bar span width
            $parentTab.find('.vertical-progress-bar-span').css('width', progressWidth + '%');
        }
        
        updateProgress($section.find('.desktop-tab'));
        updateProgress($section.find('.mobile-side'));
    }

    $('.event-page-tab-event-section').each(function() {
        initEventPageTabEvent($(this));
    });

    $(document).on('shopify:section:load', function(event) {
        $(event.target).find('.event-page-tab-event-section').each(function() {
            initEventPageTabEvent($(this));
        });
    });
  
    if ($('.breadcrumbs-section').length) {
      
    }
  
    if ($('.after-sale-policy-section').length) {
        var hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').height();
        $('.nav-list-vertical').css('top', `${hAnnouncementbarDynamic + 25 }px`);
        $('.tab-selector-policy').css('top', `${hAnnouncementbarDynamic }px`);
        
        $(window).resize(function() {
            var hAnnouncementbarDynamic = $('.shopify-section-group-header-group .header').height();
            $('.nav-list-vertical').css('top', `${hAnnouncementbarDynamic + 25 }px`);
            $('.tab-selector-policy').css('top', `${hAnnouncementbarDynamic }px`);
        });
        
        $(window).scroll(function() {
            scrollNav();
        })
        scrollNav();
        
        function scrollNav() {
            const sections = $('.content-section');
            let currentSection = '';
        
            sections.each(function() {
                const sectionTop = $(this).offset().top - 250;
                const sectionHeight = $(this).height();
                if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
                    currentSection = $(this).data('anchor');
                }
            });
        
            const links = $('.nav-list-vertical ul li');
            links.removeClass('active');
            links.filter('[data-nav="' + currentSection + '"]').addClass('active');
        }
        
        
        $('.nav-list-vertical ul li').click(function() {
            const targetSection = $(this).data('nav');
        
            $('.content-section').removeClass('active');
        
            $('.content-section[data-anchor="' + targetSection + '"]').addClass('active');
            $('.nav-list-vertical ul li').removeClass('active');
            $(this).addClass('active');
            // Update the URL with the ?tab=targetSection
            window.history.pushState(null, null, '?tab=' + targetSection);
        
        });
        
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('tab')) {
            const tabValue = urlParams.get('tab');
            console.log(urlParams)
            setTimeout(() => {
                $(`.nav-list-vertical [data-nav="${tabValue}"]`).trigger('click');
            }, 100);
        }
        
        
        $('.selector-list-container p').click(function() {
            const targetSection = $(this).data('nav');
        
            $('.content-section').removeClass('active');
        
            $('.content-section[data-anchor="' + targetSection + '"]').addClass('active');
            $('.selector-list-container p').removeClass('active');
            $(this).addClass('active');
            // Update the URL with the ?tab=targetSection
            window.history.pushState(null, null, '?tab=' + targetSection);
        
            $('.selector-list').removeClass('active');
            $('.selector-list-container').css('display', 'none');
        
            $('.selector-list h3 .selector').text($(this).text());
        });
        
        
        $(document).on('click', '.selector-list h3', function(event) {
            event.stopPropagation(); // Prevents the click from propagating to the document
            $('.selector-list').toggleClass('active');
            let container = $('.selector-list-container');
            if (container.css('display') === 'none') {
                container.css('display', 'flex');
            } else {
                container.css('display', 'none');
            }
        });
        
        // Click outside to close
        $(document).on('click', function(event) {
            if (!$(event.target).closest('.tab-selector-policy').length) {
                $('.selector-list').removeClass('active');
                $('.selector-list-container').css('display', 'none');
            }
        });
    }
  
    scrollSupportNav();
  
});

function filterLocation(country, location) {
    let append = 0;
    let show = current_store_data;
    
    if (country.toLowerCase() !== 'USA') {
        show = show.filter(x => 
            x.location.toLowerCase().indexOf(country.toLowerCase()) >= 0
        );
    }
    if (location.toLowerCase() !== '') {
        show = show.filter(x => 
            x.address.toLowerCase().indexOf(location.toLowerCase()) >= 0 || 
            x.store_name.toLowerCase().indexOf(location.toLowerCase()) >= 0
        );
    }

    if (show.length > 0) {
        $('.main-tab-container[data-store-tab="'+ current_tab +'"] .row').html('');
        
        for (let store in show) {
            let storeData = show[store];
        
            if (current_tab === 'online_store') {
                append = `
                          <div class="col-lg-3 col-md-3 col-sm-12">
                              <a href="${storeData.store_url}" target="_blank" class="online-store-item t-d-none">
                                  <div class="store-logo-container">
                                      <img src="${storeData.store_logo}" width="100%" height="100%">
                                  </div>
                                  <p class="pp-regular body-sm text-center d-lg-block d-md-block d-sm-none">${storeData.store_name}</p>
                                  <p class="pp-regular body-lg text-center d-lg-none d-md-none d-sm-block">${storeData.store_name}</p>
                              </a>
                          </div>
                        `;
            } else {
        
                append = `
                    <div class="col-12">
                        <div class="store-item">
                            <h4 class="pp-semibold body-xl mb-2">${storeData.store_name}</h4>
                            <ul>
                                ${storeData.address ? `
                                <li>
                                    <img class="icon" src="https://cdn.shopify.com/s/files/1/0474/8365/0202/files/location.png?v=1749219696" width="100%" height="100%">
                                    <p>${storeData.address}</p>
                                </li>` : ''}
        
                                ${storeData.contact_number ? `
                                <li>
                                    <img class="icon" src="https://cdn.shopify.com/s/files/1/0474/8365/0202/files/phone.png?v=1749219696" width="100%" height="100%">
                                    <p>${storeData.contact_number}</p>
                                </li>` : ''}
        
                                ${storeData.email ? `
                                <li>
                                    <img class="icon" src="https://cdn.shopify.com/s/files/1/0474/8365/0202/files/email.png?v=1749219696" width="100%" height="100%">
                                    <p>${storeData.email}</p>
                                </li>` : ''}
        
                                ${storeData.website ? `
                                <li>
                                    <img class="icon" src="https://cdn.shopify.com/s/files/1/0474/8365/0202/files/website.png?v=1749219696" width="100%" height="100%">
                                    <p>${storeData.website}</p>
                                </li>` : ''}
                            </ul>
                        </div>
                    </div>
                `;
        
            }
        
            $('.main-tab-container[data-store-tab="'+ current_tab +'"] .row').append(append);
        }



    }
    else {
        $('.main-tab-container[data-store-tab="'+ current_tab +'"] .row').html('<div class="no-found">No store found.</div>');
    }
}

function scrollSupportNav() {
    if ($('.support-nav').length) {

        let nav_1 = $('[data-anchor="product-support"]');
        let nav_2 = $('[data-anchor="support-service"]');
        let nav_3 = $('[data-anchor="where-to-buy"]');
        let nav_4 = $('[data-anchor="after-sales-policy"]');
        let nav_5 = $('[data-anchor="faq"]');

        if (!nav_1.length)
            $('.support-nav [data-nav="product-support"]').remove();
        if (!nav_2.length)
            $('.support-nav [data-nav="support-service"]').remove();
        if (!nav_3.length)
            $('.support-nav [data-nav="where-to-buy"]').remove();
        if (!nav_4.length)
            $('.support-nav [data-nav="after-sales-policy"]').remove();
        if (!nav_5.length)
            $('.support-nav [data-nav="faq"]').remove();

        const sections = $('section');
        let currentSection = '';

        sections.each(function () {
            const sectionTop = $(this).offset().top - 200;
            const sectionHeight = $(this).height();
            if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
                currentSection = $(this).data('anchor');
            }
        });

        const links = $('.support-nav .nav-items span');
        links.removeClass('active');
        links.filter('[data-nav="' + currentSection + '"]').addClass('active');
    }
}

$(window).on('scroll', function() {
    if ($('.main-product-support-nav').length) {
        let nav = $('.product-tutorials ');
        let navTop = nav.offset().top - 200; // Get the element's position from the top
        let scrollPosition = $(window).scrollTop(); // Get the current scroll position
        if (scrollPosition >= navTop) {
            $('.main-product-support-nav').removeClass('active');
        } else {
            $('.main-product-support-nav').addClass('active');
        }
    }
  
    scrollSupportNav();

});


$('.mobile-tooltips').on('click', function (e) {
  e.stopPropagation(); // prevent click bubbling (optional)

  const $existingTooltip = $('.floating-tooltip');
  const $desc = $(this).find('.benefits-description');
  const offset = $(this).offset();

  // If tooltip already exists, remove it (toggle behavior)
  if ($existingTooltip.length) {
    $existingTooltip.remove();
  } else {
    const clone = $desc.clone().addClass('floating-tooltip');

    clone.css({
      position: 'absolute',
      top: offset.top + $(this).height(),
      left: 20,
      zIndex: 9999,
      bottom: 'unset',
      display: 'block'
    }).appendTo('body');
  }
});

// Optional: Close tooltip when clicking anywhere else
$(document).on('click', function () {
  $('.floating-tooltip').remove();
});
